import styled from 'styled-components';

export const Container = styled.div`
  width: 29.6rem;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 0.2rem;
`;

export const Header = styled.div`
  display: flex;
  padding: 1.75rem 0rem 0rem 1.75rem;
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 16.9424px;
  line-height: 21px;
  color: #212326;
  margin-left: 0.6rem;
`;

export const Photo = styled.div`
  display: flex;
  padding: 1.75rem 0rem 0rem 1.75rem;
`;

export const Image = styled.img`
  border-radius: 3.63rem;
  max-width: 3.63rem;
  min-width: 3.63rem;
  max-height: 3.63rem;
  min-height: 3.63rem;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;

  text-align: left;

  Button {
    justify-content: flex-start;
  }
`;

export const GreyLine = styled.div`
  margin-top: 1rem;
  border: 0.941243px solid #eff1f5;
  background: #eff1f5;
`;

export const Body = styled.div`
  margin-left: 1.5rem;
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  width: 26.5rem;
`;

export const Info1 = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2rem;

  color: #212326;
`;

export const Info2 = styled.span`
  margin: 0.4rem 0rem 0rem 0rem;

  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #7e858f;
`;

export const BodyInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 26.5rem;
  margin-top: 1rem;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 2rem;
  margin-right: 2rem;
  margin-bottom: 2rem;
`;
